module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [_c('header', {
    staticClass: "article__header"
  }, [_c('h1', {
    staticClass: "article__title"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "article__main"
  }, [_c('p', {
    staticClass: "article__text"
  }, [_vm._v("В настоящий момент раздел находится в разработке. Скоро здесь появится актуальная информация о правилах подтверждения данных и активации сертификатов. Если у вас есть вопросы, свяжитесь с технической поддержкой, контакты указаны в нижней части сайта. Следите за информацией!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61070ddc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/article/Article.vue
// module id = 752033081f5d96d05ded
// module chunks = 0